export default {
  loaded: false,
  mobile: false,
  touch: false,
  menu: false,
  detail: null,
  firebase: null,
  formStatus: null,
  nextType: 'default',
};
